import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginButton: false,
    // 本地收藏，已不再使用
    // caseCollection: [],
    highlightText: '',
  },
  mutations: {
    changeLoginButton(state) {
      state.loginButton = !state.loginButton;
    },
    // addCaseCollection(state, payload) {
    //   state.caseCollection.push(payload)
    // },
    // removeCaseCollection(state, id) {
    //   state.caseCollection.splice(state.caseCollection.findIndex(item => item[0] === id), 1)
    // },
    setHighlightText(state, text) {
      state.highlightText = text
    }
  },
  getters: {
    // indexOfCaseCollection: (state) => (id) => state.caseCollection.findIndex(item => item[0] === id)
  },
  actions: {

  },
  //plugins: [createPersistedState()]
})
